import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { motion, AnimatePresence } from 'framer-motion';
import { HiMenu, HiX } from 'react-icons/hi';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    'about',
    'experience',
    'volunteering',
    'skills',
    'projects',
    'certifications',
    'testimonials',
    'contact',
  ];

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto flex justify-between items-center py-3 sm:py-4 md:py-5 px-4 sm:px-6 md:px-8 lg:px-12">
        <Link to="hero" smooth={true} duration={500}>
          <motion.div
            className="flex items-center gap-2 sm:gap-3 cursor-pointer"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <div className={`h-10 w-10 sm:h-12 sm:w-12 rounded-full flex items-center justify-center transition-all ${
              scrolled
                ? 'bg-gradient-to-br from-beige-400 to-beige-600 shadow-md'
                : 'bg-gradient-to-br from-beige-300 to-beige-500'
            }`}>
              <img
                alt="Wajiha Niazi"
                src="/logo.png"
                className={`h-6 w-6 sm:h-7 sm:w-7 transition-all ${scrolled ? '' : 'brightness-0 invert'}`}
              />
            </div>
            <span className={`text-lg sm:text-xl md:text-2xl font-bold font-primary transition-colors ${scrolled ? 'text-navy-900' : 'text-white'}`}>
              Wajiha
            </span>
          </motion.div>
        </Link>

        <ul className="hidden md:flex items-center gap-6 lg:gap-8">
          {navItems.map((section) => (
            <li key={section}>
              <Link
                to={section}
                smooth={true}
                duration={500}
                spy={true}
                offset={-80}
                className={`cursor-pointer text-sm lg:text-base font-medium transition-colors ${
                  scrolled
                    ? 'text-gray-700 hover:text-beige-600'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
              </Link>
            </li>
          ))}
        </ul>
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className={`md:hidden text-2xl sm:text-3xl transition-colors p-2 -mr-2 ${
            scrolled ? 'text-navy-900' : 'text-white'
          }`}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
            className="md:hidden bg-white shadow-lg"
          >
            <ul className="px-4 sm:px-6 py-4 sm:py-6 space-y-2">
              {navItems.map((section) => (
                <li key={section}>
                  <Link
                    to={section}
                    smooth={true}
                    duration={500}
                    spy={true}
                    offset={-80}
                    className="block py-3 sm:py-4 text-base sm:text-lg text-gray-700 hover:text-beige-600 font-medium cursor-pointer transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {section.charAt(0).toUpperCase() + section.slice(1)}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
